<template>
	<div class="modal-backdrop-vue d-flex justify-content-center align-items-center" role="dialog">
        <div class="modal-vue d-flex flex-column ui-dialog ui-widget ui-widget-content" :class="modalClass" ref="modal" aria-labelledby="modalTitle" aria-describedby="modalDescription">
        	<div class="ui-dialog-titlebar ui-widget-header ui-helper-clearfix" id="modalTitle">
        		<slot name="header">
        			<button type="button" class="btn-close" @click="close" aria-label="Close modal">x</button>
        		</slot>
                <button type="button" @click="close" class="ui-button ui-widget ui-state-default ui-button-icon-only ui-dialog-titlebar-close" role="button" title="Close"><span class="ui-button-icon-primary ui-icon ui-icon-closethick"></span><span class="ui-button-text">Close</span></button>
        	</div>
        	<section class="small ui-dialog-content ui-widget-content" id="modalDescription">
        		<slot name="body"></slot>
        	</section>
        	<div>
        		<slot name="footer">
        			<button type="button" class="btn btn-secondary" @click="close" aria-label="Close modal">Close</button>
        		</slot>
        	</div>
        </div>
	</div>
</template>

<script>
	import { computed } from '@vue/composition-api';

	//Component idea taken from https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
    export default {
        name: 'Modal',
		props: {
			size: String
		},
		setup (props) {
			const modalClass = computed(() => {
				let computedClass = '';

				switch (props.size) {
					case 'xs':
						computedClass = 'modal-vue-xs';
						break;
					case 'sm':
						computedClass = 'modal-vue-sm';
						break;
					case 'md':
						computedClass = 'modal-vue-md';
						break;
					case 'lg':
						computedClass = 'modal-vue-lg';
						break;
					default:
						//do nothing
				}

				return computedClass;
			});

			return {
				modalClass
			}
		},
        methods: {
            close() {
                this.$emit('close');
            },
        }
    };
</script>

<style scoped>
    .modal-backdrop-vue {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        z-index: 1000;
    }

    .modal-vue {
        z-index: 2000 !important;
        position: initial; /*using some ui-dialog styles and need this to not be 'absolute'*/
		width: 100%;
		max-width: 700px;
		position: static !important; /* was inheriting position absolute from ui-dialog, which we dont want for this */
    }

	.modal-vue-xs {
		max-width: 300px !important;
	}

	.modal-vue-sm {
		max-width: 500px !important;
	}

	.modal-vue-md {
		max-width: 700px !important;
	}

	.modal-vue-lg {
		max-width: 1000px !important;
	}
</style>
